var _rect, _path, _circle, _circle2, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYolo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,40 L160,40 L160,160 L40,160 Z",
    fill: "none",
    stroke: "#9c44dc",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 12,
    fill: "#9c44dc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 72,
    r: 12,
    fill: "#9c44dc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72,120 L128,120",
    stroke: "#9c44dc",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 180,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "#9c44dc",
    textAnchor: "middle"
  }, "YOLO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolo);
export default __webpack_public_path__ + "static/media/yolo.3539d3d552a7acf00afe55e81f4be8bf.svg";
export { ForwardRef as ReactComponent };